import api from './api';

const templateService = {
  // Get all templates with filters
  getAllTemplates: async (params = {}) => {
    const response = await api.get('/templates', { params });
    return {
      templates: response.data.templates || [],
      pagination: response.data.pagination || {}
    };
  },

  // Get template by ID
  getTemplateById: async (id) => {
    const response = await api.get(`/templates/${id}`);
    return response.data;
  },

  // Create new template
  createTemplate: async (templateData) => {
    const response = await api.post('/templates', templateData);
    return response.data;
  },

  // Update template
  updateTemplate: async (id, templateData) => {
    const response = await api.put(`/templates/${id}`, templateData);
    return response.data;
  },

  // Delete template
  deleteTemplate: async (id) => {
    const response = await api.delete(`/templates/${id}`);
    return response.data;
  },

  // Duplicate template
  duplicateTemplate: async (id) => {
    const response = await api.post(`/templates/${id}/duplicate`);
    return response.data;
  },

  // Increment usage count
  incrementUsageCount: async (id) => {
    const response = await api.post(`/templates/${id}/use`);
    return response.data;
  },

  // Get templates by type
  getTemplatesByType: async (type) => {
    const response = await api.get(`/templates/type/${type}`);
    return response.data;
  },

  // Get template categories
  getTemplateCategories: async () => {
    const response = await api.get('/templates/meta/categories');
    return response.data;
  },
};

export default templateService;

